import dayjs from "dayjs";

/**
 * Extracts working days and common start times from existing slots
 */
export function extractDoctorPatterns(slots: any[]) {
  if (!slots || !slots.length) return { workingDays: [], commonTimes: [] };
  
  // 0 = Sunday, 1 = Monday, etc.
  const workingDays = Array.from(new Set(slots.map(s => dayjs(s.startTime).day()))).sort();
  
  // Extract unique times (HH:mm)
  const timesMap = new Map<string, { hour: number, minute: number }>();
  slots.forEach(s => {
    const d = dayjs(s.startTime);
    const key = d.format("HH:mm");
    if (!timesMap.has(key)) {
      timesMap.set(key, { hour: d.hour(), minute: d.minute() });
    }
  });

  const commonTimes = Array.from(timesMap.values()).sort((a, b) => (a.hour * 60 + a.minute) - (b.hour * 60 + b.minute));
  
  return { workingDays, commonTimes };
}

/**
 * Generates virtual slots based on patterns
 */
export function generateVirtualSlots(date: Date, patterns: { workingDays: number[], commonTimes: { hour: number, minute: number }[] }) {
  const { workingDays, commonTimes } = patterns;
  if (!workingDays.length || !commonTimes.length) return [];

  return commonTimes.map(t => {
    const startTime = dayjs(date).hour(t.hour).minute(t.minute).second(0).millisecond(0);
    const endTime = startTime.add(30, 'minute'); // Default 30 mins if unknown
    
    return {
      startHour: t.hour,
      startMinute: t.minute,
      endHour: endTime.hour(),
      endMinute: endTime.minute(),
      startTime: startTime.toISOString(),
      isPredicted: true
    };
  });
}
